import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { StyleSettings } from 'src/app/shared/services/appconfig/settings.model';
import { selectSettingStyle } from 'src/app/stores/settings';

@Component({
  selector: 'frodo-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  @Input() titleKey: string;
  @Input() cardTitleKey: string;
  @Input() styleVariant: 'logo' | 'cardOutline';
  @Input() showConnectionIndicator: boolean;
  @Output() cardClicked = new EventEmitter<void>();

  cardBackgroundColor: string;
  cardTitleColor: string;
  cardIcon: string;
  private subscription = new Subscription();

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectSettingStyle).subscribe((style) => {
        this.applyStyles(style);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onCardClick(): void {
    this.cardClicked.emit();
  }

  private applyStyles(style: StyleSettings): void {
    if (this.styleVariant === 'cardOutline') {
      this.cardBackgroundColor = style.primaryColor;
      this.cardTitleColor = style.secondaryFontColor;
      this.cardIcon = style.icons.cardOutline;
    } else {
      this.cardBackgroundColor = style.primaryFontColor;
      this.cardTitleColor = style.fourthFontColor;
      this.cardIcon = style.icons.logoIcon;
    }
  }
}
